import { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "../../../../utils/withRouter";
import { ToastContainer } from "react-toastify";
import StaticFooter from "../../common_components/StaticFooter";
import StaticHeader from "../../common_components/staticHeader";
import $ from "jquery";
import { getCurrentAwardDetails_action, getActiveJuryDetails_action } from "../../../../actions/static_action/currentAwardDetails_action";
import { BASE_URL, toastError } from "../../../../utils/constants";
import Loader from "../../../../utils/Loader";
import lightGallery from "lightgallery";
import lgThumbnail from "lightgallery/plugins/thumbnail";
import "lightgallery/css/lightgallery.css";
import "lightgallery/css/lg-thumbnail.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "slick-carousel";
import moment from "moment";
import { Modal } from "react-bootstrap";
import Carousel from "../../common_components/carousel";
import { getCmsContent_action } from "../../../../actions/cms_action/cmsAction";
import SiteMaintenance from "../../common_components/siteMaintenance";

class Index extends Component {
  constructor(props) {
    super(props);
    this.state = {
      currentIndex: 0,
      awardCarouselList: [],
      isLoading: false,
      isSiteMaintenance: false,
      awardEventYear: "",
      awardEventName: "",
      venueDate: "",
      venueName: "",
      awardEventDecription: "",
      award_address: "",
      speakers: [],
      JuryName: '',
      JuryPDF: '',
      isOpen: false,
      isOpen3: false,
      isOpenWinner: true,
      applicationStartDate: '',
      applicationEndDate: '',
      currentDate: '',
      isOpen2: false,
      LaunchDate: '',
      //cms
      cmsSectionData: [],
      MenuID: '', MenuUrl: '',
      cmsMenuData: [], cmsFooterData: [],
      isHomePage: false, cmsBannerData: []
    };
    this.slidesToShow = 5;
    this.slideInterval = 3000;
  }

  componentDidMount() {
    if (JSON.parse(sessionStorage.getItem("AwardsUserLoginData")) == null) {
      if (sessionStorage.getItem("role_id") === 1) {
        this.props.navigate("/adminDashboard");
      }
      setTimeout(() => {
        this.props.navigate("/");
      }, 500);
    }
    if (this.props.location.pathname == '/') {
      this.setState({ MenuUrl: 'home', MenuID: 1, cmsMenuData: [] }, () => {
        this.getCmsContent(1, 'home');
        this.getCurrentAwardDetails();
        this.getActiveJuryDetails()
      });
      return
    }

    const urlHash = this.props.location.pathname;
    console.log(this.props.location, 'did');


    if (urlHash) {
      const parts = urlHash.split('&');

      if (parts.length === 2) {
        const MenuUrl = parts[0];
        const MenuID = parts[1];

        console.log("Menu URL:", MenuUrl);
        console.log("Menu ID:", MenuID);

        this.setState({ MenuUrl: MenuUrl ? MenuUrl : 'home', MenuID: MenuID ? MenuID : 1, cmsMenuData: [] }, () => {
          this.getCmsContent(MenuID ? MenuID : 1, MenuUrl ? MenuUrl : 'home');
          this.getCurrentAwardDetails();
          this.getActiveJuryDetails()
        });

      }
    }

  }

  componentDidUpdate(prevProps) {
    if (this.props.location.pathname !== prevProps.location.pathname) {
      const urlHash = this.props.location.pathname;
      console.log(this.props.location, 'did');

      if (urlHash.includes('current-awards&4')) {
        window.open('#/category', '_blank');
      } else if (urlHash == '/') {
        this.setState({ MenuUrl: 'home', MenuID: 1, cmsMenuData: [] }, () => {
          this.getCmsContent(1, 'home')
        })
      } else {
        if (urlHash) {
          const parts = urlHash.split('&');

          if (parts.length === 2) {
            const MenuUrl = parts[0];
            const MenuID = parts[1];
            if (MenuID === '1') {
              window.location.reload();
              return;
            }

            this.setState({ MenuUrl, MenuID, cmsMenuData: [] }, () => {
              this.getCmsContent(MenuID, MenuUrl);
            });
          }
        }
      }
    }
  }

  jQuery = () => {
    $(document).ready(function () {
      const galleryElement = document.getElementById("selector1");
      if (galleryElement) {
        lightGallery(galleryElement, {
          selector: ".item",
          plugins: [lgThumbnail],
          allowMediaOverlap: true,
          toggleThumb: true,
        });
      } else {
        console.warn("Element with ID 'selector1' not found.");
      }

      $(document).on("click", "#back-to-top, .back-to-top", function () {
        $("html, body").animate({ scrollTop: 0 }, 500);
        return false;
      });

      $(window).on("scroll", function () {
        if ($(window).scrollTop() > 500) {
          $("#back-to-top").fadeIn(200);
        } else {
          $("#back-to-top").fadeOut(200);
        }
      });

      // Initialize Slick slider only if not already initialized
      if (!$(".testimonial-slide").hasClass("slick-initialized")) {
        $(".testimonial-slide").slick({
          infinite: true,
          slidesToShow: 2,
          slidesToScroll: 2,
          autoplay: true,
          autoplaySpeed: 2000,
          arrows: false,
          dots: false,
          responsive: [
            {
              breakpoint: 600,
              settings: { slidesToShow: 1, slidesToScroll: 1 },
            },
          ],
        });
      }
    });
  }


  loadscript() {
    $(document).ready(function () {
      $(this).scrollTop(0);
    });
  }

  componentWillUnmount() {
    clearInterval(this.autoSlideInterval);
  }

  startAutoSlide = () => {
    this.autoSlideInterval = setInterval(() => {
      this.moveSlide(1);
    }, this.slideInterval);
  };

  moveSlide = (step) => {
    const { currentIndex, awardCarouselList } = this.state;
    const totalSlides = awardCarouselList.length;
    const newIndex = (currentIndex + step + totalSlides) % totalSlides;
    this.setState({ currentIndex: newIndex });
  };

  getCurrentAwardDetails() {
    this.setState({ isLoading: true });
    const { award_event_profile_id } = this.state;

    this.props
      .getCurrentAwardDetails_action(
        award_event_profile_id != "" ? award_event_profile_id : null
      )
      .then((data) => {
        if (data.error != 1) {
          if (data.applicationDate != "") {
            const now = moment().format('DD-MM-YYYY');
            const startDate = moment(data.applicationDate[0]["application_start_date"]).format('DD-MM-YYYY');
            const endDate = moment(data.applicationDate[0]["application_end_date"]).format('DD-MM-YYYY');
            this.setState({
              applicationStartDate: startDate,
              applicationEndDate: endDate,
              currentDate: now,
            });
          }
          if (data.data != "") {
            const formattedDate = moment(
              data.data[0]["award_event_to_date"]
            ).format("DD MMM YYYY");
            const year = moment(data.data[0]["award_event_to_date"]).format(
              "YYYY"
            );
            this.setState({
              isLoading: false,
              awardCarouselList: data.data,
              awardEventYear: year,
              awardEventName: data.data[0]["award_event_name"],
              award_address: data.data[0]["award_address"],
              awardEventDecription: data.data[0]["award_event_description"],
              venueDate: formattedDate,
              venueName: "",
            });
            if (data.data2.length > 0) {
              sessionStorage.setItem(
                "award_event_id",
                data.data2[0]["award_event_id"]
              );
              setTimeout(() => {
                this.getActiveJuryDetails()
              }, 100);
            }
          } else {
            this.setState({
              isLoading: false,
            });
          }
        } else {
          this.setState({ isLoading: false });
          toastError(data.msg);
        }
      })
      .catch((err) => {
        this.setState({ isLoading: false });
        console.log(err);
      });
  }

  getActiveJuryDetails() {
    this.setState({ isLoading: true });
    const award_event_id = sessionStorage.getItem("award_event_id")

    this.props
      .getActiveJuryDetails_action(
        award_event_id != "" ? award_event_id : null
      )
      .then((data) => {
        if (data.error != 1) {
          if (data.data != "") {
            const filterArray = []
            data.data.map((item => {
              filterArray.push(
                {
                  name: item.name,
                  role: item.designation,
                  company_name: item.company_name,
                  imgSrc: item.profile_image != null ? BASE_URL.split('/api')[0] + item.profile_image : null,
                  juryDetailsPdf: item.profile_filepath != null ? BASE_URL.split('/api')[0] + item.profile_filepath : null
                }
              )
            }))
            this.setState({
              isLoading: false,
              speakers: filterArray
            });
          } else {
            this.setState({
              isLoading: false,
            });
          }
        } else {
          this.setState({ isLoading: false });
          toastError(data.msg);
        }
      })
      .catch((err) => {
        this.setState({ isLoading: false });
        console.log(err);
      });
  }

  onAwardApply(award_event_profile_id) {
    if (award_event_profile_id != null) {
      this.props.navigate("/category", {
        state: {
          award_event_profile_id: award_event_profile_id,
          isAllCategory: false,
        },
      });
    } else {
      this.props.navigate("/category", { state: { isAllCategory: true } });
    }
  }

  //cms
  async getCmsContent(MenuID, MenuUrl) {
    // const formattedMenuUrl = MenuUrl?.startsWith('/') ? MenuUrl.substring(1) : MenuUrl;
    try {
      this.setState({ isLoading: true });

      const data = await this.props.getCmsContent_action(MenuID ? MenuID : 1, MenuUrl ? MenuUrl : 'home');
      if (data.error !== 1) {
        this.setState({
          isLoading: false,
          cmsSectionData: data?.data[0] !== "" ? data?.data[0] : [],
          cmsMenuData: data?.data[1] !== "" ? data?.data[1] : [],
          cmsFooterData: data?.data[2][0] !== "" ? data?.data[2][0] : [],
          cmsUploadData: data?.data[3] !== "" ? data?.data[3] : [],
          cmsSubheaderData: data?.data[4] !== "" ? data?.data[4] : [],
          cmsBannerData: data?.data[5][0] !== "" ? data?.data[5][0] : [],
          isOpen3: MenuID == 1 ? true : false
        }, () => {
          this.startAutoSlide();
          this.loadscript();
          this.jQuery();
        });
      } else {
        this.setState({ isLoading: false });
        toastError(data.msg);
        if (data.msg == 'Page not found.') {
          if (this.props.location.pathname.includes('cms/manage')) {
            window.location.reload()
            this.props.navigate('/cms/manage')
          } else {
            window.location.reload()
            this.props.navigate('/')
          }
        }
      }
    } catch (err) {
      console.error(err);
      this.setState({ isLoading: false });
    }
  }

  render() {
    const {
      awardCarouselList, isLoading, awardEventName, speakers, cmsBannerData,
      JuryName, JuryPDF, currentDate, applicationStartDate, applicationEndDate, isOpenWinner,
      //cms
      cmsSectionData, MenuID, cmsMenuData, cmsFooterData, isOpen3, isSiteMaintenance
    } = this.state;
    function parseDate(dateString) {
      const [day, month, year] = dateString.split("-").map(Number);
      return new Date(year, month - 1, day);
    }
    return (
      <>
        <StaticHeader headerNavs={cmsMenuData} />
        {isSiteMaintenance ? <SiteMaintenance /> : (isLoading ? <Loader></Loader> : null)}
        <>
          <div className="website">
            {MenuID == 1 && <>
              <section className="banner position-relative pb-0">
                <div className="overlay"></div>
                <div className="container">
                  <div className="inner-banner position-relative text-white ">
                    <div className="row">
                      <div className="col-lg-10">
                        <div className="banner-right  ms-2 text-center text-lg-start pb-8">
                          <div className="banner-title pb-3">
                            {/* <h4 className="text-white pb-3">
                                         UPCOMING <span className="pink">AWARDS</span>
                                       </h4> */}
                            <h1 className="text-white">
                              <span className="pink">{awardEventName ? awardEventName : 'India ITME Awards'}</span>{" "}
                            </h1>
                            <h5 style={{ color: 'white' }}>Exclusively for Textile Technology & Engineering Sectors</h5>
                          </div>
                          <div className="banner-event-info pb-3">
                            <ul className="m-0 ps-0 d-sm-flex justify-content-center justify-content-lg-start list-unstyled">
                              {/* <li className="pe-2 border-end border-1 border-lightgrey">
                                           <i className="fa  fa-calendar-o pe-1" />{" "}
                                           {venueDate}
                                         </li>
                                         <li className="ps-2">
                                           <i className="fa  fa-map-marker pe-1" />
                                           {award_address}
                                         </li> */}
                              {console.log(applicationStartDate, applicationEndDate, 'app')}

                              {(!applicationStartDate && !applicationEndDate) ? (
                                <></>
                                // <li className="pe-2 text-white border-0" style={{ borderRight: '0px !important' }}>
                                //   <i className="fa fa-calendar-o pe-1" /> Launching - 21 Feb, 2025
                                // </li>
                              ) : (
                                parseDate(applicationStartDate) > parseDate(currentDate) ? (
                                  <li className="pe-2 text-white border-0" style={{ borderRight: '0px !important' }}>
                                    <i className="fa fa-calendar-o pe-1" /> Launching - {applicationStartDate && moment(applicationStartDate, 'DD-MM-YYYY').format('DD MMM, YYYY')}
                                  </li>
                                ) : (
                                  applicationStartDate === currentDate ? (
                                    <li className="pe-2 text-white border-0" style={{ borderRight: '0px !important' }}>
                                      <i className="fa fa-calendar-o pe-1" /> The application process has started
                                    </li>
                                  ) : (parseDate(applicationStartDate) <= parseDate(currentDate) && parseDate(currentDate) <= parseDate(applicationEndDate)) ? (
                                    //till then adjustments from prabhat sir on 31-07-2025
                                    <li className="pe-2 text-white border-0" style={{ borderRight: '0px !important' }}>

                                    </li>
                                  ) :
                                    (
                                      (parseDate(applicationStartDate) <= parseDate(currentDate)) && (parseDate(currentDate) <= parseDate(applicationEndDate)) ? (
                                        <li className="pe-2 text-white border-0" style={{ borderRight: '0px !important' }}>
                                          <i className="fa fa-calendar-o pe-1" /> Last date of application submission - {applicationEndDate && moment(applicationEndDate, 'DD-MM-YYYY').format('DD MMM, YYYY')}
                                        </li>
                                      )
                                        : (
                                          parseDate(currentDate) > parseDate(applicationEndDate) ? (
                                            <li className="pe-2 text-white border-0" style={{ borderRight: '0px !important' }}>
                                              <i className="fa fa-calendar-o pe-1" /> The application closed on - {applicationEndDate && moment(applicationEndDate, 'DD-MM-YYYY').format('DD MMM, YYYY')}
                                            </li>
                                          ) : (
                                            <li className="pe-2 text-white border-0" style={{ borderRight: '0px !important' }}>
                                              <i className="fa fa-calendar-o pe-1" /> The application will coming soon
                                            </li>
                                          )
                                        )
                                    )
                                )
                              )}

                            </ul>
                          </div>
                          {/* <div className="event-discription">
                                       <p className="pb-4 m-0" >
                                         {awardEventDecription}
                                       </p>
                                     </div> */}
                        </div>
                      </div>

                      <div className="col-lg-2 text-center">
                        {/* <div className="video-box">
                                     <a href="https://youtu.be/ag47pOihPx4" className="play-btn" target="_blank" rel="noopener noreferrer">
                                       <img className="rotate360" src="../static/images/heroShape2_1.png" alt="shape" />
                                     </a>
                                   </div> */}
                        {/* <div class="video-box">
               <a href="https://youtu.be/ag47pOihPx4" class="play-btn" target="_blank" rel="noopener noreferrer">
                 <div class="wave-container">
                   <img class="rotate-animation" src="../static/images/heroShape2_1.png" alt="shape" />
                 </div>
               </a>
             </div> */}

                        <div class="video-box">
                          <a href="https://www.youtube.com/watch?v=WWBKrtKRCWk" class="play-btn" target="_blank" rel="noopener noreferrer">
                            <div class="wave-container">
                              <div class="wave-bg"></div>
                              <img class="rotate-animation" src="../static/images/heroShape2_1.png" alt="shape" />
                            </div>
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </section>
              <section
                className="news-archive pb-0"
                style={{ paddingTop: 60, paddingBottom: 0, position: "relative" }}
              >
                <div
                  className="container"
                  style={{ transform: "translate(0%, -32%)" }}
                >
                  <div className="news-archive-inner">
                    <div className="speaker-title text-center p-2">
                      <div className="row align-items-center ">
                        <div className="col-lg-6"></div>
                      </div>
                    </div>
                    <div className="row gy-5">
                      {awardCarouselList.length > 0 ? <>
                        <div className="col-lg-12">
                          {awardCarouselList.length > 0 ? <Carousel state={{ awardCarouselList: awardCarouselList, screen: 'index' }} /> : <></>}
                        </div>
                      </> : <></>}
                      {awardCarouselList.length > 0 ?
                        <div className="speaker-button text-lg-center m-0 mt-3 text-center">
                          <a
                            className="btn my-2"
                            onClick={() => this.onAwardApply(null, null)}
                          >
                            See all Awards{" "}
                            <i className="fa fa-angle-double-right" />
                          </a>
                        </div> : <></>}
                    </div>
                  </div>
                </div>
              </section>
            </>}
            <>
              {MenuID == 1 ? <>
                {cmsSectionData?.length > 0 ? (
                  <>
                    {cmsSectionData
                      .filter(section => section.isPublish && section.isactive)
                      .sort((a, b) => a.SeqNo - b.SeqNo)
                      .slice(0, 2)
                      .map((section, index) => (
                        <section key={section.ContentID || index} className="p-0">
                          <div
                            dangerouslySetInnerHTML={{
                              __html: section.SectionContent,
                            }}
                          />
                        </section>
                      ))}
                    {/* Static Jury Section in Between */}
                    <section
                      className="ticket1 position-relative bg-lightgrey"
                      style={{ padding: "70px 0px" }}
                    >
                      <div className="container">
                        <div className="ticket-inner  text-center position-relative">
                          <div className="ticket-title mx-auto">
                            <h2 className="mb-2">
                              Our <span className="pink">Jury</span> <br />
                              <span style={{ fontSize: 20 }}>
                                Expert Voices, Fair Judgments
                              </span>
                            </h2>
                            <div className="app">
                              <div className="speaker-grid">
                                {speakers.map((speaker, index) => (
                                  <div key={index} className="speaker-card">
                                    <div className="image-container-outline">
                                      <div className="image-container">
                                        {speaker.imgSrc ? (
                                          <img
                                            src={speaker.imgSrc}
                                            alt={speaker.name}
                                            onClick={() =>
                                              speaker.juryDetailsPdf &&
                                              this.setState({
                                                JuryPDF: speaker.juryDetailsPdf,
                                                isOpen: true,
                                                JuryName: speaker.name,
                                              })
                                            }
                                            className="speaker-image"
                                          />
                                        ) : (
                                          <img
                                            src={"img/profile_img.png"}
                                            alt="Profile Preview"
                                            className="rounded-circle profile-pic"
                                            width="170"
                                            height="165"
                                            onClick={() =>
                                              speaker.juryDetailsPdf &&
                                              this.setState({
                                                JuryPDF: speaker.juryDetailsPdf,
                                                isOpen: true,
                                                JuryName: speaker.name,
                                              })
                                            }
                                          />
                                        )}
                                      </div>
                                    </div>
                                    <div className="social-icons">
                                      <a href="#" className="icon">
                                        <i className="ri-facebook-line"></i>
                                      </a>
                                      <a href="#" className="icon">
                                        <i className="ri-twitter-line"></i>
                                      </a>
                                      <a href="#" className="icon">
                                        <i className="ri-instagram-line"></i>
                                      </a>
                                      <a href="#" className="icon">
                                        <i className="ri-linkedin-line"></i>
                                      </a>
                                    </div>
                                    <h3 className="speaker-name">{speaker.name}</h3>
                                    <p className="speaker-company">{speaker.company_name}</p>
                                    <p className="speaker-role">{speaker.role}</p>
                                  </div>
                                ))}
                              </div>
                            </div>
                          </div>
                          <div className="ticket-info w-lg-65 mx-auto">
                            <p>
                              This is the idea which drives India ITME Society’s search for
                              talented, stand out leaders, innovators and determined
                              perseverance in their field of work. To mark 4-decade old
                              successful journey of India ITME Society an award was initiated
                            </p>
                            <div className="ticket-button">
                              <a className="btn" onClick={() => this.props.navigate('/jury')}>
                                Read More <i className="fa fa-angle-double-right" />
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                    </section>
                    {/* Continue remaining dynamic sections */}
                    {cmsSectionData
                      .filter(section => section.isPublish && section.isactive)
                      .sort((a, b) => a.SeqNo - b.SeqNo)
                      .slice(2)
                      .map((section, index) => (
                        <section key={section.ContentID || index + 2} className="p-0">
                          <div
                            dangerouslySetInnerHTML={{
                              __html: section.SectionContent,
                            }}
                          />
                        </section>
                      ))}
                  </>
                ) : null}
              </> : <>
                {cmsSectionData?.length > 0 ? (
                  <>
                    {cmsSectionData
                      .filter(section => section.isPublish && section.isactive)
                      .sort((a, b) => a.SeqNo - b.SeqNo)
                      .map((section, index) => (
                        <section style={{ paddingTop: '165px' }} key={section.ContentID || index} className="p-0">
                          <div
                            dangerouslySetInnerHTML={{
                              __html: section.SectionContent,
                            }}
                          />
                        </section>
                      ))}
                  </>) : <>
                  <section style={{ paddingTop: '165px', textAlign: 'center' }}>
                    <p>No Records Found</p>
                  </section>
                </>}
              </>}


              {/* WHAT PEOPLES'S SAYS ABOUT */}
              {/* <section className="testimonial bg-lightgrey">
                <div className="container">
                  <div className="section-title w-lg-60 m-auto text-center pb-5">
                    <h2 className="mb-1 text-center website-title">TESTIMONIALS</h2>
                    <p className="m-0">
                      Testimonials provide real insights into the impact of the
                      awards on individuals and organizations.
                    </p>
                  </div>
                  <div className=" testimonial-slide">
                    <div className="box1 pl-3 pt-3 pb-3 rounded  ">
                      <div className="testimonial-content position-relative text-justify pt-2">
                        <i className="fa fa-quote-left position-absolute" />
                        <p className="my-6 position-relative w-md-90 m-6 ">
                          Encouragement and recognition are essential for people
                          to innovate and grow to their full potential. While
                          there are many prestigious awards, the India ITME
                          Society promotes necessary niche categories and
                          provides proper due diligence to the selection
                          process. I am extremely proud to be on the jury panel
                          and highly impressed by the caliber of nominations.
                        </p>
                      </div>
                      <div className="testimonial-bio d-flex align-items-center">
                        <img
                          src="static/images/uday_gill.jpg"
                          alt=""
                          className="bio-img me-5 rounded-circle float-start"
                        />
                        <div>
                          <p className="mb-1 fw-semibold black">
                            Mr. Uday Gill
                          </p>
                          <p>
                            Group Chief Strategy Officer, Fibers, Indorama
                            Ventures Ltd.
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="box2 pl-3 pt-3 pb-3 rounded  text-justify">
                      <div className="testimonial-content position-relative">
                        <i className="fa fa-quote-left position-absolute" />
                        <p className="my-6 position-relative w-md-90 ms-6 mr-4">
                          Winning India ITME Awards will be an accelerator for
                          the growth of engineering firms. The Society’s wide
                          network will not only enhance the company’s reputation
                          amongst the fellow industry but among the most
                          prestigious customer industry of the sector. Credits
                          to Society for curating such an enormous opportunity
                          for recognition. The award formations and the
                          precision in the collection of information for the
                          evaluation was perfectly poised
                        </p>
                      </div>
                      <div className="testimonial-bio d-flex align-items-center text-justify">
                        <img
                          src="static/images/updeep_singh.jpg"
                          alt=""
                          className="bio-img me-5 rounded-circle float-start"
                        />
                        <div>
                          <p className="mb-1 fw-semibold black">
                            Mr. Updeep Singh
                          </p>
                          <p>
                            Director, Growth Initiatives At Welspun Living
                            Limited{" "}
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="box3 pl-3 pt-3 pb-3 rounded  text-justify">
                      <div className="testimonial-content position-relative">
                        <i className="fa fa-quote-left position-absolute" />
                        <p className="my-6 position-relative w-md-90 ms-6 mr-4">
                          I have been fortunate to be a jury member for the
                          India ITME Society awards since its inception in 2019.
                          The award nominations for both editions have simply
                          amazed me. Having worked in our engineering sector for
                          decades, this technology award creation by the Society
                          was a feeling of achievement since it will yield
                          deserving recognition to fellow Indian machinery
                          producers. The domain-specific categories and the keen
                          focus on encouraging women leaders by bringing
                          extremely talented women leader’s nominations is an
                          inspirational work done by the Society. It will be my
                          utmost honor to continue this journey of aiding
                          recognition and mentorship for our industry. I am sure
                          the competition will go tougher and tougher as the
                          success of other will inspire other competitors to
                          further enhance their game.
                        </p>
                      </div>
                      <div className="testimonial-bio d-flex align-items-center text-justify">
                        <img
                          src="static/images/gurudas_v.JPG"
                          alt=""
                          className="bio-img me-5 rounded-circle float-start"
                        />
                        <div>
                          <p className="mb-1 fw-semibold black">
                            Mr. Gurudas V Aras
                          </p>
                          <p>
                            Strategic Advisor, Independent Director, Former
                            Director At A.T.E. Group{" "}
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="box3 pl-3 pt-3 pb-3 rounded ">
                      <div className="testimonial-content position-relative">
                        <i className="fa fa-quote-left position-absolute" />
                        <p className="my-6 position-relative w-md-90 ms-6 mr-4 text-justify">
                          India ITME is always presenting opportunities &amp;
                          platforms for the manufacturers and businessmen from
                          the textile industry and the textile engineering
                          industry. ITME Awards is another excellent opportunity
                          for the awardee organization to showcase their
                          innovation and build their reputation across the
                          textile horizon globally taking advantage of ITME
                          global connect. International exhibitors, Government
                          representatives, Business visitors and buyers, foreign
                          delegates, Embassy &amp; Consulates will all be
                          present at the Technology Award Function.
                        </p>
                      </div>
                      <div className="testimonial-bio d-flex align-items-center">
                        <img
                          src="static/images/sanjiv.JPG"
                          alt=""
                          className="bio-img me-5 rounded-circle float-start"
                        />
                        <div>
                          <p className="mb-1 fw-semibold black">
                            Mr. Sanjiv Lathia
                          </p>
                          <p>Past Chairman of India ITME Society </p>
                        </div>
                      </div>
                    </div>
                    <div className="box3 pl-3 pt-3 pb-3 rounded ">
                      <div className="testimonial-content position-relative">
                        <i className="fa fa-quote-left position-absolute" />
                        <p className="my-6 position-relative w-md-90 ms-6 mr-4 text-justify">
                          India ITME Awards motive of felicitating and
                          encouraging innovations, research in every edition is
                          a remarkable feat now beknownst to all segments of
                          textiles. They are trying to bridge the gap between
                          academic research and industry application. With the
                          introduction of “Research Excellence” capturing
                          students, faculty and institutes is an encouraging
                          work which will truly inspire more and more faculty
                          and students to invest in finding innovative and
                          sustainable practical solutions
                        </p>
                      </div>
                      <div className="testimonial-bio d-flex align-items-center">
                        <img
                          src="static/images/manisha_m.JPG"
                          alt=""
                          className="bio-img me-5 rounded-circle float-start"
                        />
                        <div>
                          <p className="mb-1 fw-semibold black">
                            Dr. Manisha Mathur
                          </p>
                          <p>Joint Director, SASMIRA </p>
                        </div>
                      </div>
                    </div>
                    <div className="box3 pl-3 pt-3 pb-3 rounded ">
                      <div className="testimonial-content position-relative">
                        <i className="fa fa-quote-left position-absolute" />
                        <p className="my-6 position-relative w-md-90 ms-6 mr-4 text-justify">
                          An award is a brilliant tool to inspire excellence in
                          a chosen domain, given the visibility and pride that
                          come with it. They truly help organizations in
                          benchmarking their products, processes and services
                          with peers and also in sharpening execution skills
                          through cross learning. Being the leading
                          representative of the Textile Engineering sector,
                          India ITME Society has always encouraged a spirit of
                          innovation and entrepreneurship for the sector’s
                          growth. Conceptualizing the awards encompassing a wide
                          spectrum - Technology, Individual and Sustainability
                          is one such wonderful initiative. I enjoyed being
                          amongst the elite jury and believe me, we had a tough
                          time in drawing out winners from outstanding
                          contributions. I wish India ITME, the award winners
                          and all participants the very best in their journey of
                          excellence and nation building.
                        </p>
                      </div>
                      <div className="testimonial-bio d-flex align-items-center">
                        <img
                          src="static/images/manohar_s.JPG"
                          alt=""
                          className="bio-img me-5 rounded-circle float-start"
                        />
                        <div>
                          <p className="mb-1 fw-semibold black">
                            Mr. Manohar Samuel
                          </p>
                          <p>Advisor, R&amp;D Reliance Retail </p>
                        </div>
                      </div>
                    </div>
                    <div className="box3 pl-3 pt-3 pb-3 rounded ">
                      <div className="testimonial-content position-relative">
                        <i className="fa fa-quote-left position-absolute" />
                        <p className="my-6 position-relative w-md-90 ms-6 mr-4 text-justify">
                          India ITME Society's goal is to promote textile
                          machinery manufacturers in India. With the ITME
                          awards, we are trying to create a gateway for building
                          more visibility and recognition for our fellow
                          technology manufacturers and inspire more investment
                          in India for textile machinery and technology. We
                          would also like to celebrate the increasing
                          participation of women in leadership positions in the
                          textile and textile engineering industries.
                        </p>
                      </div>
                      <div className="testimonial-bio d-flex align-items-center">
                        <img
                          src="static/images/ketan_s.JPG"
                          alt=""
                          className="bio-img me-5 rounded-circle float-start"
                        />
                        <div>
                          <p className="mb-1 fw-semibold black">
                            Mr. Ketan Sanghvi
                          </p>
                          <p>Chairman, India ITME Society</p>
                        </div>
                      </div>
                    </div>
                    <div className="box3 pl-3 pt-3 pb-3 rounded ">
                      <div className="testimonial-content position-relative">
                        <i className="fa fa-quote-left position-absolute" />
                        <p className="my-6 position-relative w-md-90 ms-6 mr-4 text-justify">
                          Every edition of India ITME Society awards will try to
                          do justice and grow bigger, better &amp; bolder by
                          introducing strategic categories and reaching a wider
                          audience. The credit for the growth of the awards goes
                          to none other than the fellow participants themselves.
                          It is their dedication and hard work that add value to
                          the award categories. We are grateful for all the
                          applications received which were exceptional in their
                          domain. We also thank every applicant for their belief
                          in the society and urge all the other fellow companies
                          to participate in the next edition and help us build a
                          bigger and bolder award ceremony during the next
                          editions.{" "}
                        </p>
                      </div>
                      <div className="testimonial-bio d-flex align-items-center">
                        <img
                          src="static/images/harishankar.JPG"
                          alt=""
                          className="bio-img me-5 rounded-circle float-start"
                        />
                        <div>
                          <p className="mb-1 fw-semibold black">
                            Mr. Hari Shankar
                          </p>
                          <p>Imm Past Chairman, India ITME Society</p>
                        </div>
                      </div>
                    </div>
                    <div className="box3 pl-3 pt-3 pb-3 rounded ">
                      <div className="testimonial-content position-relative">
                        <i className="fa fa-quote-left position-absolute" />
                        <p className="my-6 position-relative w-md-90 ms-6 mr-4 text-justify">
                          I have seen India ITME society adding value in each
                          and every activity year by year. It was a great honor
                          to be associated with their vibrant success stories.
                          Of course, ITME award ceremony was also a great honor
                          to be with leaders of industry and dynamic ITME
                          management team. Our first edition was for
                          associations across India and in this edition we
                          decided to give justice to the industry in all
                          segments from research to innovation, from corporate
                          leaders to tribal communities, from woman empowerment
                          to green initiatives. It was real encouraging
                          assignment with heavy weigh jury members and a great
                          association with ITME board members.
                        </p>
                      </div>
                      <div className="testimonial-bio d-flex align-items-center">
                        <img
                          src="static/images/avinash_m.JPG"
                          alt=""
                          className="bio-img me-5 rounded-circle float-start"
                        />
                        <div>
                          <p className="mb-1 fw-semibold black">
                            Mr. Avinash Mayekar
                          </p>
                          <p>Managing Director of Suvin</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </section> */}
              <Modal show={this.state.isOpen} size="lg">
                <Modal.Header>
                  <Modal.Title style={{ width: '100%', textAlign: 'center' }}>
                    {/* <div > */}
                    <h6> {JuryName} </h6>
                    {/* </div> */}
                  </Modal.Title>
                  <span
                    onClick={() => this.setState({ isOpen: false })}
                    style={{ cursor: "pointer", fontWeight: "800", marginRight: '15px' }}
                  >
                    X
                  </span>
                </Modal.Header>
                <Modal.Body style={{ height: 'calc(100vh - 76px)' }}>
                  <iframe
                    id="myIframe"
                    // src={`/${sessionStorage.getItem("sessionExhibitionID")}/Rules-and-Regulations.pdf#toolbar=0&navpanes=0`}
                    src={`${JuryPDF}#toolbar=0&navpanes=0`}
                    // src={`${juryDetailsPdf}`}
                    width="100%"
                    height="95%"
                    title="Bing"
                  >
                    &lt;/div&gt; &lt;div style="height: 100px;"&gt;&lt;/div&gt;
                    &lt;/div&gt; &lt;/div&gt; &lt;/div&gt;
                  </iframe>
                </Modal.Body>

                {/* <Modal.Footer style={{ justifyContent: 'right' }}>
                  <div class="row">
                    <div class="col-md-12">
                      <button
                        onClick={() => this.setState({ isOpen: false })}
                        class="btn btn-dark"
                        style={{ cursor: 'pointer', width: 'auto' }}
                      >
                        Back
                      </button>
                    </div>
                  </div>

                </Modal.Footer> */}
              </Modal>
            </>
          </div>
          {/* Update End */}
          <StaticFooter footerData={cmsFooterData} />
        </>
        {cmsBannerData?.isActive ? <>
          {cmsBannerData.isPublish ? <>
            <Modal
              show={this.state.isOpen3}
              onHide={() => this.setState({ isOpen3: false })}
              centered
              backdrop="static"
              size="lg"
              contentClassName="bg-transparent border-0 shadow-none"
            >
              <Modal.Body className="p-0 position-relative">
                <button
                  onClick={() => this.setState({ isOpen3: false })}
                  className="btn position-absolute top-0 end-0 m-2 rounded-circle d-flex align-items-center justify-content-center border-white border-2 text-white p-0 shadow"
                  style={{
                    width: "32px",
                    height: "32px",
                    backgroundColor: "rgba(0,0,0,0.6)",
                    zIndex: 10,
                    fontSize: "20px",
                    lineHeight: "0"
                  }}
                >
                  &times;
                </button>
                <div className="container p-0">
                  <img width='100%' height='100%'
                    src={cmsBannerData?.BannerFilepath}
                    alt="WebBanner"
                  />
                </div>
              </Modal.Body>
            </Modal>
          </> : <></>}
        </> : <></>}
        <Modal show={this.state.isOpen2} size="lg" style={{ width: '620px' }}>
          <Modal.Body
            style={{
              backgroundImage: 'url("../static/images/login-page-bg.jpg")',
              backgroundSize: 'cover',
              backgroundPosition: 'center',
              backgroundRepeat: 'no-repeat',
            }}
          >
            <span
              className="pop-close"
              onClick={() => this.setState({ isOpen2: false })}
            >
              X
            </span>
            <div className="container text-center p-4">
              <img
                src="../static/images/pop-logo.png"
                alt="logo"
                className="image timer-pop"
              />
              <h3 className="py-5 text-center com-soon-tag">Coming Soon</h3>
              <h5 className="timer-pop-text com-soon">
                The registration will start on 21<sup>st</sup> February 2025 at 12:00
                noon (IST)
              </h5>
              <h5 className="pt-3 mb-0 pb-0 timer-pop-text com-soon">
                The registration will be on first come first basis.
              </h5>
              <div className="countdown-out mt-2">
                <div class="countdown">
                  <div>
                    <span id="days">30</span>
                    <small>Days</small>
                  </div>
                  <div>
                    <span id="hours">02</span>
                    <small>Hours</small>
                  </div>
                  <div>
                    <span id="minutes">41</span>
                    <small>Minutes</small>
                  </div>
                  <div>
                    <span id="seconds">07</span>
                    <small>Seconds</small>
                  </div>
                </div>
              </div>x
            </div>
          </Modal.Body>
        </Modal>
        {/* <Modal
          show={this.state.isOpenWinner}
          onHide={() => this.setState({ isOpenWinner: false })}
          centered
          backdrop="static"
          size="lg" // Limits width on desktop, auto-scales on mobile
          contentClassName="bg-transparent border-0 shadow-none" // Removes white box and borders
        >
          <Modal.Body className="p-0 position-relative">
            <button
              onClick={() => this.setState({ isOpenWinner: false })}
              className="btn position-absolute top-0 end-0 m-2 rounded-circle d-flex align-items-center justify-content-center border-white border-2 text-white p-0 shadow"
              style={{
                width: "32px",
                height: "32px",
                backgroundColor: "rgba(0,0,0,0.6)",
                zIndex: 10,
                fontSize: "20px",
                lineHeight: "0"
              }}
            >
              &times;
            </button>

            <a
              href="https://corporate.india-itme.com/wp-content/uploads/2025/11/Press-Release-India-ITME-Technical-Awards-Winners-Announcement.pdf"
              target="_blank"
              rel="noopener noreferrer"
              className="d-block"
            >
              <img
                src="https://awards.india-itme.com/document/Static/1/Winners pop-up.jpg"
                alt="Winner Announcement"
                className="img-fluid rounded-4 shadow-lg w-100"
              />
            </a>

          </Modal.Body>
        </Modal> */}
        <ToastContainer />
      </>
    );
  }
}
export default withRouter(
  connect(null, { getCurrentAwardDetails_action, getActiveJuryDetails_action, getCmsContent_action })(Index)
);
